// CONFIGURACAO DO REDUX
import { persistStore } from 'redux-persist';

import createSagaMiddleware from 'redux-saga';
import persistedReducers from './persistReducers';

import createStore from './createStore';

import rootReducer from './modules/rootReducer';
import rootSaga from './modules/rootSaga';

const sagaMiddlewares = createSagaMiddleware();

const middlewares = [sagaMiddlewares];

const store = createStore(persistedReducers(rootReducer), middlewares);

const persistor = persistStore(store);

sagaMiddlewares.run(rootSaga);

export { store, persistor };
